import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {PatientVademecumFormValidationSchema} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'

export const PatientVademecumFields = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<PatientVademecumFormValidationSchema>()

    // form observer
    const vademecum = useWatch({control: form.control, name: 'vademecum'})

    return (
        <Flexbox direction="column" gap={3}>
            <FormFieldBox fitContent isSelected={!!vademecum} hasError={!!form.formState.errors.vademecum}>
                <Checkbox id="vademecum" label={t('patients:vademecum_signed')} {...form.register('vademecum')} />
            </FormFieldBox>
        </Flexbox>
    )
}
